import { render, staticRenderFns } from "./WaitingValuesMobile.vue?vue&type=template&id=352ddb0a&scoped=true&"
import script from "./WaitingValuesMobile.vue?vue&type=script&lang=js&"
export * from "./WaitingValuesMobile.vue?vue&type=script&lang=js&"
import style0 from "./WaitingValuesMobile.vue?vue&type=style&index=0&id=352ddb0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352ddb0a",
  null
  
)

export default component.exports